const SectionTitle = () => import("@/components/SectionTitle/SectionTitle.vue");
import downloadPDF from "@/mixins/downloadPDF";
import Utils from "@/mixins/Utils";
import terminology from "@/mixins/terminology";
import documentService from "@/services/document";
import difService from "@/services/dif";
import { mapGetters } from "vuex";
import { KEYWORDS } from "../../constants/support";
import { COMPONENT_KEYWORD } from "../../constants/variables";
import axios from "axios";

import moment from "moment";

moment.locale("fr");
const nodeEnv =  window.configs && window.configs.NODE_ENV !== "" 
? window.configs.NODE_ENV: process.env.NODE_ENV;
export default {
  components: {
    SectionTitle,
  },
  data: () => ({
    perPage: 5,
    perPageMandataire: 5,
    perPageService: 5,
    perPageServiceFolder: 6,
    currentPage: 1,
    currentMandatairePage: 1,
    currentPageService: 1,
    currentPageServiceFolder: 1,
    fichesPaie: [],
    mandatairePaire: [],
    notesService: [],
    loadingPayLeaves: true,
    errorPayLeaves: false,
    loadingNotesService: true,
    errorNotesService: false,
    loadingAttestations: true,
    errorAttestations: false,
    checkAnyAttestation: true,
    currentModalId: -1,
    nbDIF: null,
    currentNotesServiceFolder: [],
    documentsToSign: [],
    loadingDocumentSign: false,
    hidden: nodeEnv !== 'development',
    keyword: {
      mandataire: KEYWORDS.DEF_MANDATAIRE,
      prestataire: KEYWORDS.DEF_PRESTATAIRE
    },
    unsignedDocError: null,
    welcomeKitFile: null
  }),
  mixins: [downloadPDF, Utils, terminology],
  computed: {
    ...mapGetters("auth", {
      user: 'getUser'
    }),
    listFichesPaie() {
      // Return just page of items needed
      return this.fichesPaie.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    listMandatairePaie() {
      return this.mandatairePaire.slice(
        (this.currentMandatairePage - 1) * this.perPageMandataire,
        this.currentMandatairePage * this.perPageMandataire
      );
    },
    getDocumentComponent() {
     documentService.getComponentBykeyword(COMPONENT_KEYWORD.DOCUMENTS_WELCOME_KIT).then((res)=> {
      
     })
    },
    listNotesService() {
      // Return just page of items needed
      return this.notesService.slice(
        (this.currentPageService - 1) * this.perPageService,
        this.currentPageService * this.perPageService
      );
    },
    listNotesServiceFolder() {
      // Return just page of items needed
      if (this.currentModalId != -1 && this.currentNotesServiceFolder) {
        return this.currentNotesServiceFolder.content.slice(
          (this.currentPageServiceFolder - 1) * this.perPageServiceFolder,
          this.currentPageServiceFolder * this.perPageServiceFolder
        );
      } else {
        return [];
      }
    },
    currentRouteFullName() {
      return this.$router.currentRoute.fullPath;
    },
  },

  created() {
    this.getFichesPaie();
    this.getNotesService();
    this.getDIFHours();
    this.getDocumentsToSign();
    this.getDocumentWelcomeKit();
  },

  methods: {
    async downloadItem ({ urlFile, fileName }) {
      
      try {
        const a = document.createElement("a");
        a.href = urlFile;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch(err) {
        console.log({ err })
      }
    }
    ,
    getDocumentWelcomeKit() {
      documentService.getComponentBykeyword({keyword:COMPONENT_KEYWORD.DOCUMENTS_WELCOME_KIT}).then((res)=> {
         if(res && res.components) {
          this.welcomeKitFile = res.components[0];

         }
      })
     },
    goTo(url) {
      const vue = this;
      if (vue.user.isMandataire && !vue.user.isPrestataire) {
        vue.callToaster(vue.$t('msg-access-right-for-madataire'));
      } else {
        window.open(url, "_blank");
      }
    },
    openModal(id) {
      const vue = this;
      if (vue.user.isMandataire && !vue.user.isPrestataire) {
        vue.callToaster(vue.$t('msg-access-right-for-madataire'));
      } else {
        vue.currentModalId = id;
        vue.currentNotesServiceFolder = vue.notesService.find(
          (note) => note.id === vue.currentModalId
        );
        this.$refs["noteServiceFolder"].show();
      }
    },
    getDocumentsToSign() {
      this.loadingDocumentSign = true;
      documentService.getDocumentsToSign().then(response => {
        if(response.success && response.data) {
          this.documentsToSign = response.data;
        }
        if (!response.success) {
          this.unsignedDocError = this.$t('error occurred-while-loading-your-unsigned-documents');
        }
      }).catch(err => {
        this.unsignedDocError = this.$t('error occurred-while-loading-your-unsigned-documents');
      })
        .finally(() => {
        this.loadingDocumentSign = false;
      });
    },
    handleDownloadDocument(doc) {
      // TODO: Handle download document
      return;
    },
    getFichesPaie() {
      const vue = this;
      documentService
        .getPayslips()
        .then(function(response) {
          if (response.success) {
            vue.fichesPaie = response.data.filter(item => !item.IS_MANDATAIRE);
            vue.mandatairePaire = response.data.filter(item => item.IS_MANDATAIRE);
          } else {
            vue.errorPayLeaves = true;
          }
        })
        .catch(function(error) {
          vue.errorPayLeaves = true;
          console.error(error);
        })
        .finally(function() {
          vue.loadingPayLeaves = false;
        });
    },
    getNotesService() {
      const vue = this;
      documentService
        .getMemos()
        .then(function(response) {
          vue.currentModalId = -1;
          vue.currentNotesServiceFolder = [];
          vue.notesService = response.data;
          vue.notesService.forEach((note) => {
            note.startDate = moment(note.startDate).format("DD/MM/YYYY");
            note.content.forEach((noteIn) => {
              noteIn.startDate = moment(noteIn.startDate).format("DD/MM/YYYY");
            });
          });
        })
        .catch(function(error) {
          vue.currentModalId = -1;
          vue.currentNotesServiceFolder = [];
          vue.errorNotesService = true;
          console.error(error);
        })
        .finally(function() {
          vue.loadingNotesService = false;
        });
    },
    getDIFHours() {
      const vue = this;
      difService
        .getDIFHours()
        .then(function(response) {
          if (response.success) {
            vue.nbDIF = response.data.dif;
          } else {
            vue.errorAttestations = true;
          }
        })
        .catch(function(error) {
          vue.errorAttestations = true;
        })
        .finally(function() {
          vue.loadingAttestations = false;
          vue.checkAttestationConditions();
        });
    },
    checkAttestationConditions() {
      const vue = this;
      if (vue.nbDIF != null && vue.nbDIF != "0" && vue.nbDIF != 0) {
        vue.checkAnyAttestation = true;
      } else {
        vue.checkAnyAttestation = false;
      }
    },
    dateFormat(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    genererAttestationDIF() {
      const vue = this;
      difService
        .generateAttestationDIF()
        .then(function(response) {
          if (response.success) {
            vue.filePath = response.data.filePath;
            vue.checkFileExistanceAndDownload(vue.filePath);
          } else {
            vue.callToaster(
              `${vue.$t("error-generate-DIF")}: ${response.message}`
            );
          }
        })
        .catch(function(error) {
          vue.callToaster(vue.$t("error-generate-DIF"));
        });
    },
    onDownload(link) {
      const vue = this;
      if (vue.user.isMandataire && !vue.user.isPrestataire) {
        vue.callToaster(vue.$t('msg-access-right-for-madataire'));
      } else {
        vue.checkFileExistanceAndDownload(link)
      }
    }
  },
};
